import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }

import CheckField from '@/components/fields/CheckField.vue'
import { useArrayMap } from '@vueuse/core'
import * as _ from 'lodash-es'
import { toRef } from 'vue'

interface Props {
  /** The options to display in the checklist */
  options: ChecklistOption[]
  /** Whether to apply hover styles to the options */
  hover?: boolean
  /** Whether to apply boxed styles to the options */
  boxed?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'BaseChecklist'
},
  __name: 'BaseChecklist',
  props: /*@__PURE__*/_mergeModels({
    options: {},
    hover: { type: Boolean },
    boxed: { type: Boolean }
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

// @ts-check



const selectedValues = _useModel<unknown[]>(__props, "modelValue")



const mappedOptions = useArrayMap(
  toRef(() => __props.options),
  (option) => ({
    ...option,
    key: JSON.stringify(option.value),
    value: _.some(selectedValues.value, (value) =>
      _.isEqual(option.value, value)
    )
  })
)

const onSelectOption = ({ key }: { key: string }) => {
  let newSelectedOptions = []

  if (!selectedValues.value.some((value) => JSON.stringify(value) === key)) {
    newSelectedOptions = [...selectedValues.value, JSON.parse(key)]
  } else {
    newSelectedOptions = selectedValues.value.filter(
      (value) => JSON.stringify(value) !== key
    )
  }

  selectedValues.value = newSelectedOptions
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mappedOptions), (option) => {
      return (_openBlock(), _createElementBlock("li", {
        key: option.key
      }, [
        _createVNode(CheckField, {
          class: _normalizeClass(["px-3 py-2", {
          'hover:bg-secondary-100': __props.hover,
          boxed: __props.boxed
        }]),
          "model-value": option.value,
          "onUpdate:modelValue": ($event: any) => (onSelectOption(option))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(option.label), 1)
          ]),
          _: 2
        }, 1032, ["class", "model-value", "onUpdate:modelValue"])
      ]))
    }), 128))
  ]))
}
}

})